import type { SVGProps } from 'react';

export const Flag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 13.5V20c0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55V5.4c0-.25.083-.458.25-.625A.889.889 0 0 1 6.4 4.5h6.45c.217 0 .408.067.575.2a.805.805 0 0 1 .3.525L14 6.5h4.6a.81.81 0 0 1 .625.275.81.81 0 0 1 .275.625v7.2a.89.89 0 0 1-.275.65.848.848 0 0 1-.625.25h-4.45a.895.895 0 0 1-.575-.2.805.805 0 0 1-.3-.525L13 13.5H7Zm7.65.5H18V8h-4.5a.915.915 0 0 1-.9-.725L12.35 6H7v6h6.5a.915.915 0 0 1 .9.725L14.65 14Z" />
    </svg>
  );
};
